import * as React from 'react';
import { CoreTooltip } from '../internal/WixUiCoreComponents/components/CoreTooltip';
import { getArrowByPlacement } from './Arrows';
import { Placement } from '../internal/WixUiCoreComponents/components/CorePopover';
import { st, classes } from './Tooltip.st.css';
import { TooltipProps, TooltipSkin } from './types';

const customArrow = (placement: Placement, arrowProps) => {
  const ArrowSvg = getArrowByPlacement(placement);

  return (
    <div className={classes.tpaArrow} {...arrowProps}>
      <ArrowSvg />
    </div>
  );
};

const Tooltip: React.FunctionComponent<TooltipProps> = (props) => {
  const {
    className,
    skin = TooltipSkin.Standard,
    maxWidth = 240,
    ...rest
  } = props;

  return (
    <CoreTooltip
      className={st(classes.root, { skin: props.skin }, className)}
      timeout={{ enter: 120, exit: 80 }}
      customArrow={customArrow}
      maxWidth={maxWidth}
      {...rest}
    />
  );
};

Tooltip.displayName = 'Tooltip';

export { Tooltip };
